
/**
 * @ngdoc service
 * @name internshipmocker
 *
 * @description Internship getter mock.
 */
module.factory('internships', function (drupal) {
    'use strict';

    return {
        getInternships: function () {
            return drupal.getInternships();
        },
        getInternship: function () {
            return {};
        }
    };
});
